import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { guestOnlyControlTowerGuard } from '@core/guards/guest.guard';
import { AuthGuardService } from '@core/services/auth/auth-guard.service';
import { AuthInitResolver } from '@core/services/auth/auth-init-resolver.service';
export const APP_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
    canActivate: [AuthGuardService],
    data: { routeId: 'wizard' },
  },
  // Public self-signup routes - reached without a session, or from an email link
  {
    path: 'signup',
    loadChildren: () => import('./modules/signup/signup.module').then(m => m.SignupModule),
  },
  // Public OTP verification route - accessible without authentication
  {
    path: 'otp-verification',
    loadChildren: () => import('./modules/otp-verification/otp-verification.module').then(m => m.OtpVerificationModule),
  },
  // Public view-only dashboard link (/shared/view/:token); ai-reporting's SHARED_LINK_ROOT
  {
    path: 'shared',
    loadChildren: () => import('./modules/ai-reporting/ai-reporting.module').then(m => m.AiReportingModule),
  },
  {
    path: '',
    loadComponent: () => import('./app-wrapper/app-wrapper.component').then(m => m.AppWrapperComponent),
    loadChildren: () => import('./app-wrapper/app-wrapper.module').then(m => m.AppWrapperModule),
    resolve: { auth: AuthInitResolver },
    canActivateChild: [guestOnlyControlTowerGuard],
  },
  {
    path: 'procurement',
    loadChildren: () =>
      import('./modules/procurement/procurement-routing.module').then(m => m.ProcurementRoutingModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(APP_ROUTES, { preloadingStrategy: PreloadAllModules, enableTracing: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
